declare global {
  interface Window {
    authUtils: typeof authUtils;
  }
}

export const authUtils = {
  login: (args: Record<string, any> = {}) =>
    window.dispatchEvent(
      new CustomEvent('auth-login', {
        detail: { args },
      })
    ),

  logout: (args: Record<string, any> = {}) =>
    window.dispatchEvent(
      new CustomEvent('auth-logout', {
        detail: { args },
      })
    ),

  getAuthState: () => ({
    isAuthenticated: !!sessionStorage.getItem('accessToken'),
    token: sessionStorage.getItem('accessToken'),
    user: JSON.parse(sessionStorage.getItem('keycloak-user') || 'null'),
  }),
};
